// https://fordprofile.cms.dealer.com/2024-Ford-F-150.htm
export default {
	events: {
		'ddc.link.generic': [
			{
				logic: ({ eventData }) => {
					// Build & Action CTA
					// french and spanish locales all give english.
					return eventData.text === 'Build & Price';
				},
				payload: {
					directCall: 'global-onclick',
					payload: {
						onclick: {
							onclick: 'reveal:content:bp',
							onclickLinkName: '{client}reveal:content:action'
						}
					}
				},
				trigger: 'build-and-price-referral-exit'
			},
			{
				logic: ({ eventData }) => {
					// includes model=F-150 and year=2024 for the CTA params
					// For Explore F-150 and View Inventory for this pageType
					return eventData.url.includes(
						'/new-inventory/index.htm?model=F-150'
					);
				},
				payload: {
					directCall: 'global-onclick',
					payload: {
						onclick: {
							onclick: 'reveal:content:view inventory',
							onclickLinkName: '{client}reveal:content:action'
						}
					}
				}
			}
		]
	},
	triggerEvents: {
		'build-and-price-referral-exit': {
			payload: {
				directCall: 'referral-exit',
				payload: {
					onclick: {
						onclick: 'referral:bp',
						referredTo: 'bp',
						onclickLinkName: 'referral:exit'
					},
					event: {
						action: 'brand referral'
					}
				}
			}
		}
	}
};
